<template>
  <div id="question">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>培训考试&nbsp;/&nbsp;题库管理</span>
      </div>
      <div style="display: flex; flex-wrap: wrap; align-items: center">
        <Provinces @gain="gainSS"></Provinces>
        <el-input
          class="elinputs"
          v-model="beginData.title"
          placeholder="题目"
        ></el-input>
        <el-select
          v-model="beginData.tisshow"
          placeholder="是否显示"
          class="elinputs"
        >
          <el-option
            v-for="item in beginData.tisshows"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
        <el-button
          type="primary"
          element-loading-text="加载中..."
          element-loading-background="rgba(0, 0, 0, 0.4)"
          v-loading.fullscreen.lock="fullscreenLoading"
          @click="query"
          >查询</el-button
        >
        <el-button type="info" @click="resets">重置</el-button>
      </div>
      <div class="tit">
        <Reset @clkBtn="theBtn"></Reset>
        <Xlsx :name="formname"></Xlsx>
      </div>
      <el-table
        :data="tableData"
        @selection-change="handleSelectionChange"
        id="exportTab"
        border
        stripe
        style="width: 100%"
      >
        <el-table-column type="selection" width="60"></el-table-column>
        <el-table-column
          type="index"
          label="序号"
          width="80"
          :index="1"
        ></el-table-column>
        <el-table-column
          prop="title"
          label="题目"
          width="200"
        ></el-table-column>
        <el-table-column
          prop="areasName"
          label="所属地区"
          width="160"
        ></el-table-column>
        <el-table-column
          prop="correctOption"
          label="正确答案"
          width="160"
        ></el-table-column>
        <el-table-column
          prop="optionA"
          label="选项A内容"
          width="160"
        ></el-table-column>
        <el-table-column
          prop="optionB"
          label="选项B内容"
          width="160"
        ></el-table-column>
        <el-table-column
          prop="optionC"
          label="选项C内容"
          width="160"
        ></el-table-column>
        <el-table-column
          prop="optionD"
          label="选项D内容"
          width="160"
        ></el-table-column>
        <el-table-column label="是否显示" width="110">
          <template slot-scope="scope">
            <p class="boldfont" v-if="scope.row.tisshow == 0">是</p>
            <p
              class="boldfont"
              v-if="scope.row.tisshow == 1"
              style="color: #f56c6c"
            >
              否
            </p>
          </template>
        </el-table-column>
        <el-table-column
          prop="createtime"
          sortable
          label="创建时间"
          width="180"
        ></el-table-column>
        <el-table-column
          prop="modifytime"
          sortable
          label="修改时间"
          width="180"
        ></el-table-column>

        <el-table-column label="操作" fixed="right" min-width="180">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="success"
              @click="handleEdit(2, scope.row, 'question:update')"
              ><i class="el-icon-edit"></i> 编辑</el-button
            >
            <el-button
              size="mini"
              type="danger"
              @click="stop(scope.row, 'question:delete')"
              ><i class="el-icon-delete"></i> 删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="paging">
        <span>
          共
          <i class="pagingNum">{{ total }}</i> 条
        </span>
        <Paging :gopage="total" @pag="pag"></Paging>
      </div>
    </el-card>
    <el-dialog
      title="添加/编辑"
      :visible.sync="dialogFormVisible"
      @close="dataClose"
      width="60%"
    >
      <el-form>
        <!-- <el-form-item label="* 所属分类">
                    <el-select v-model="details.cid" placeholder="请选择">
                    <el-option
                    v-for="item in cidList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item> -->
        <el-form-item label="* 所属地区：">
          <el-select v-model="sheng" placeholder="省份" @change="cksheng">
            <el-option
              v-for="item in shenglist"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
          <el-select v-model="shi" placeholder="城市" @change="ckshi" class="cty16">
            <el-option
              v-for="item in shilist"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="* 题 目：">
          <el-input
            type="textarea"
            placeholder="请输入题目"
            v-model="details.title"
            auto-complete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="* 选项A：">
          <el-input
            placeholder="请输入选项A内容"
            v-model="details.optionA"
            auto-complete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="* 选项B：">
          <el-input
            placeholder="请输入选项B内容"
            v-model="details.optionB"
            auto-complete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="* 选项C：" v-if="quesnum > 2">
          <el-input
            placeholder="请输入选项C内容"
            v-model="details.optionC"
            auto-complete="off"
          ></el-input
          ><i
            v-if="quesnum == 3"
            class="el-icon-delete delicon"
            @click="del"
          ></i>
        </el-form-item>
        <el-form-item label="* 选项D：" v-if="quesnum > 3">
          <el-input
            placeholder="请输入选项D内容"
            v-model="details.optionD"
            auto-complete="off"
          ></el-input
          ><i class="el-icon-delete delicon" @click="del"></i>
        </el-form-item>
        <el-form-item label=" ">
          <span
            @click="addques"
            style="cursor: pointer; text-decoration: underline; color: #11A983"
            >添加选项（最多4项）</span
          >
        </el-form-item>
        <el-form-item label="* 正确答案：">
          <el-radio v-model="details.correctOption" label="A"> A</el-radio>
          <el-radio v-model="details.correctOption" label="B"> B</el-radio>
          <el-radio
            v-model="details.correctOption"
            label="C"
            v-if="quesnum > 2"
          >
            C</el-radio
          >
          <el-radio
            v-model="details.correctOption"
            label="D"
            v-if="quesnum > 3"
          >
            D</el-radio
          >
        </el-form-item>
        <el-form-item label="* 是否显示：">
          <el-radio v-model="details.tisshow" label="0">是</el-radio>
          <el-radio v-model="details.tisshow" label="1">否</el-radio>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="puton">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Xlsx from "@/components/Xlsx";
import EditorBar from "@/components/Richtext";
import Reset from "@/components/Reset";
import Paging from "@/components/Paging";
import Provinces from "@/components/Provinces";
export default {
  name: "question",
  components: {
    Xlsx,
    EditorBar,
    Reset,
    Paging,
    Provinces,
  },
  data() {
    return {
      beginData: {
        tisshows: [
          { id: 0, name: "是" },
          { id: 1, name: "否" },
        ],
        isTops: [
          { id: 0, name: "是" },
          { id: 1, name: "否" },
        ],
      },
      tableData: [],
      pageNum: 1,
      pageSize: 10,
      dialogFormVisible: false,
      details: { tisshow: "0", istop: 0 },
      userdata: {},
      total: 0,
      btn: [],
      fullscreenLoading: true,
      formname: JSON.stringify({ name: "题库管理", hint: "question:export" }),
      cid: "",
      cidList: [],
      sheng: "",
      shengName: '',
      shi: "",
      shenglist: [],
      shilist: [],
      status: "",
      quesnum: 2,
      multipleSelection: [],
      nowCityId: "",
    };
  },
  created() {
    let btn = JSON.parse(sessionStorage.getItem("btn"));
    this.$set(this, "btn", btn);
    let userdata = JSON.parse(sessionStorage.getItem("userdata"));
    this.$set(this, "userdata", userdata);
    this.nowCityId = userdata.areasId;
    this.begin();
  },
  computed: {
    data() {
      return this.tableData;
    },
  },
  mounted() {
    // 赋值所属地区名
    this.details.areasName = this.userdata.areasName;
    // 查询下拉框分类
    let data = this.$qs.stringify({
      areasId: this.userdata.areasId,
    });
    this.$axios
      .post(`/api-e/category/categoryV`, data, {
        headers: { accessToken: this.userdata.token },
      })
      .then((res) => {
        if (res.data.success) {
          this.cidList = res.data.categoryInfoList;
        }
      });
    let region = JSON.parse(localStorage.getItem("region"));
    region.forEach((x) => {
      if (x.level == 0) {
        this.shenglist.push(x);
        this.sheng = x.id;
        this.shengName = x.name;
      }
    });
    if (this.userdata.level == 0) {
      this.$axios
        .post(
          `/api-r/area/getSubordinateAreaList`,
          this.$qs.stringify({ areasId: region[0].id }),
          { headers: { accessToken: this.userdata.token } }
        )
        .then((res) => {
          if (res.data.success) {
            this.$set(this, "shilist", res.data.areaListInfoList);
          }
        });
    } else {
      region.forEach((x) => {
        if (x.level == 1) {
          this.shilist.push(x);
        }
      });
      if (this.shilist.length == 1) {
        this.shi = this.shilist[0].id;
        this.details.areasid = this.sheng + "," + this.shilist[0].id;
        this.details.areasName = this.shengName + "," + this.shilist[0].name;
      }
    }
  },
  methods: {
    //   判断当前点击的按钮
    theBtn(i) {
      if (i == 1) {
        if (this.btn.indexOf("question:add") == -1) {
          return this.$message.error("抱歉，用户暂无该权限");
        }
        this.handleEdit(1);
      } else if (i == 2) {
        if (this.btn.indexOf("question:update") == -1) {
          return this.$message.error("抱歉，用户暂无该权限");
        }
        if (this.multipleSelection.length != 1) {
          return this.$message.error("请勾选一项内容编辑");
        }
        this.handleEdit(2, this.multipleSelection[0]);
      } else if (i == 3) {
        if (this.btn.indexOf("question:delete") == -1) {
          return this.$message.error("抱歉，用户暂无该权限");
        }
        this.choice();
      } else if (i == 4) {
        this.query();
      }
    },
    //   多选编辑
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    //   多选删除
    choice() {
      if (this.multipleSelection.length == 0) {
        return this.$message.error("请至少选择一项删除");
      }
      let arr = [];
      this.multipleSelection.forEach((x) => {
        arr.push(x.id);
      });
      this.$confirm("此操作将删除选中内容, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let url = ``;
          url = `/api-e/topic/deleteTopic/${arr.join(",")}`;
          this.$axios
            .post(url, {}, { headers: { accessToken: this.userdata.token } })
            .then((res) => {
              if (res.data.success == true) {
                this.$message({
                  type: "success",
                  message: res.data.msg,
                });
                this.begin();
              } else {
                alert(res.data.msg);
              }
            });
        })
        .catch(() => {
          return;
        });
    },
    //   删除答案
    del() {
      if (this.quesnum > 2) {
        this.quesnum--;
      }
    },
    //   添加选项
    addques() {
      if (this.quesnum < 4) {
        this.quesnum++;
      }
    },
    // 关闭清空内容
    dataClose() {
      if (this.shilist.length == 1) {
        this.details = {
          tisshow: "0",
          istop: 0,
          areasid: this.sheng + "," + this.shilist[0].id,
        };
      } else {
        this.shi = "";
        this.details = { tisshow: "0", istop: 0 };
      }
    },
    change(val) {
      console.log(val);
    },
    // 提交
    puton() {
      if (this.details.areasid == undefined || this.details.areasid == "") {
        return this.$message.error("请选择所属地区");
      }
      if (this.details.title == undefined || this.details.title == "") {
        return this.$message.error("请填写题目");
      }
      if (this.details.optionA == undefined || this.details.optionA == "") {
        return this.$message.error("请至少填写2个选项");
      }
      if (this.details.optionB == undefined || this.details.optionB == "") {
        return this.$message.error("请至少填写2个选项");
      }
      if (
        this.details.correctOption == undefined ||
        this.details.correctOption == ""
      ) {
        return this.$message.error("请选择正确答案");
      }
      let url = "";
      if (this.quesnum == 2) {
        this.details.optionC = "";
        if (this.details.correctOption == "C" || this.details.correctOption == "D") {
            return this.$message.error("请选择正确答案为A或B，不能为C或D");
        }
      }
      if (this.quesnum == 3) {
        this.details.optionD = "";
        if (this.details.correctOption == "D") {
            return this.$message.error("请选择正确答案为A、B或C，不能为D");
        }
      }
      if (this.status == 1) {
        url = `/api-e/topic/addTopic`;
      } else if (this.status == 2) {
        url = `/api-e/topic/updateTopic`;
      }
      this.fullscreenLoading = true;
      this.$axios
        .post(url, this.$qs.stringify(this.details), {
          headers: { accessToken: this.userdata.token },
        })
        .then((res) => {
          this.dialogFormVisible = false;
          this.begin();
        });
    },
    // 地区id
    cksheng(val) {
      this.$set(this, "shi", "");
    },
    ckshi(val) {
      this.details.areasid = this.sheng + "," + val;
      let addName = "";
      this.shilist.forEach((x) => {
        if (val == x.id) {
          addName = x.name;
        }
      });
      this.details.areasName = this.shenglist[0].name + "," + addName;
    },
    resets() {
      this.$router.push("/refresh");
    },
    pag(val) {
      this.pageNum = val.pageNum;
      this.pageSize = val.pageSize;
      this.fullscreenLoading = true;
      this.begin();
    },
    // 获取省市传入的id
    gainSS(i) {
      this.nowCityId = i.id;
    },
    begin() {
      let data = this.$qs.stringify({
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        id: this.beginData.id,
        tisshow: this.beginData.tisshow,
        title: this.beginData.title,
        areasid: this.nowCityId,
      });
      this.$axios
        .post(`/api-e/topic/topicLists`, data, {
          headers: { accessToken: this.userdata.token },
        })
        .then((res) => {
          this.fullscreenLoading = false;
          if (res.data.success) {
            this.$nextTick(function () {
              //不使用this.$nextTick()方法会报错
              this.$set(this, "tableData", res.data.pageInfo.list);
            });
            this.$set(this, "total", res.data.pageInfo.total);
            this.$message({
              type: "success",
              message: res.data.msg,
            });
          } else {
            this.$message(res.data.msg);
          }
        });
    },
    handleEdit(i, row, hint) {
      if (hint && this.btn.indexOf(hint) == -1) {
        return this.$message.error("抱歉，用户暂无该权限");
      }
      this.status = i;
      if (i == 2) {
        if (row.optionD == "" || row.optionD == undefined) {
          if (row.optionC == "" || row.optionC == undefined) {
            this.quesnum = 2;
          } else {
            this.quesnum = 3;
          }
        } else {
          this.quesnum = 4;
        }
        let str = row.tisshow + "";

        this.sheng = Number(row.areasid.split(",")[0]);
        this.shi = Number(row.areasid.split(",")[1]);
        row.tisshow = str;
        this.details = row;
      }
      this.dialogFormVisible = true;
      //   this.$set(this, "information", i);
    },
    stop(row, hint) {
      if (hint && this.btn.indexOf(hint) == -1) {
        return this.$message.error("抱歉，用户暂无该权限");
      }
      this.$confirm("此操作将删除该条内容, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let url = ``;
          url = `/api-e/topic/deleteTopic/${row.id}`;
          this.$axios
            .post(url, {}, { headers: { accessToken: this.userdata.token } })
            .then((res) => {
              if (res.data.success == true) {
                this.$message({
                  type: "success",
                  message: res.data.msg,
                });
                this.begin();
              } else {
                alert(res.data.msg);
              }
            });
        })
        .catch(() => {
          return;
        });
    },
    query() {
      this.fullscreenLoading = true;
      this.begin();
    },
  },
};
</script>
<style>
.w-e-toolbar {
  flex-wrap: wrap;
}
#question .el-input__inner {
  margin: 10px 0;
}
#question .el-menu.el-menu--horizontal {
  margin-bottom: 14px;
}
#question .el-menu-item.is-active {
  background: none;
}
#question .el-pagination__sizes .el-input__inner {
  margin: 0;
}
#question .delicon {
  position: absolute;
  top: 20px;
  right: -30px;
  font-size: 18px;
}
#question .el-tag {
  margin-right: 12px;
}
#question .el-select {
  /* margin: 0 8px; */
  width: 100%;
}
#question .el-upload__tip {
  display: inline-block;
  margin-left: 14px;
}
.input-new-tag {
  width: 20%;
}
#question .el-upload-list--picture .el-upload-list__item {
  width: 44%;
  float: left;
  margin-right: 2%;
}
#question .el-form-item__content {
  width: 76%;
}
#question .el-table td,
.el-table th.is-leaf {
  text-align: center;
}
/* 暂无数据样式 */
#question .el-table__empty-text {
  display: block;
  width: 500px;
  height: 240px;
  padding-top: 126px;
  background: url(../../assets/img/nothing.svg) no-repeat 50%;
  color: #909399;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  font-size: 12px;
}
#question .myxx .el-input--suffix .el-input__inner {
  border-bottom: 1px solid #dcdfe6;
  margin-bottom: 20px;
}
#question .myxx .el-input__inner {
  padding: 0 11px;
  border: none;
  border-radius: 0;
}
#question .el-dialog__body {
  height: 382px;
}
#nei .el-dialog__body {
  height: 150px !important;
}
#question .el-form-item {
  display: flex;
  align-items: center;
  margin-bottom: 0;
}
#question .el-form-item__content {
    width: 84%;
    display: flex;
    align-items: center;
}
#question .el-form-item__label {
  width: 122px;
}
#question .el-textarea__inner {
  height: 100px;
  margin: 10px 0px;
}
.viewer-transition {
  z-index: 9999 !important;
}
</style>
<style scoped lang="scss">
.clearfix {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.tit {
  display: flex;
  justify-content: space-between;
  margin: 16px 0 24px;
}
.sfzimg {
  height: 48px;
}
#help .myxx p {
  margin: 5px 0;
  font-size: 16px;
}
h5 {
  text-align: center;
  margin-top: 12px;
}
.f56 {
  background: #909399;
  color: #fff;
  border: 1px solid #909399;
}
.c23 {
  background: #409eff;
  color: #fff;
  border: 1px solid #409eff;
}
.tx {
  color: red;
  margin-left: 8px;
}
</style>
